import firebase from 'firebase/app';
import 'firebase/functions';
import 'firebase/analytics';
import 'firebase/auth';
import 'firebase/firestore';
import Vue from 'vue';
import M from '@/plugins/Materialize'
import router from '@/router'

/**@module vue/plugins/firebase
 * @desc See {@link https://firebase.google.com/} <br>
 * Plugin Wrapper for Google Firebase
 * @requires Vue
 * @requires Materialize
 * @requires VueRouter
 * @requires Firebase
*/

/**@constant
 * @default
*/
const firebaseConfig = {
    apiKey: "AIzaSyAnnxORknOzxDKJRfhJYcqXFQM26vob3_g",
    authDomain: "osca-dilg-iot.firebaseapp.com",
    databaseURL: "https://osca-dilg-iot.firebaseio.com",
    projectId: "osca-dilg-iot",
    storageBucket: "osca-dilg-iot.appspot.com",
    messagingSenderId: "486749887380",
    appId: "1:486749887380:web:9f2f268511cbd9eb870d81",
    measurementId: "G-PN5734EGDQ"
};

/** Fetch current user records from Firebase Auth and Firebase Firestore
 * @function
*/
async function fetchUser() {
    return new Promise(resolve => {
        if (firebase.auth().currentUser) {
            let user = firebase.auth().currentUser;
            Promise.all([
                user.getIdTokenResult(true).catch(() => { return null }),
                firebase.firestore().doc(`auth/${user.uid}`).get(),
            ]).then(([token, doc]) => {
                user.claims = token.claims;
                if (doc.exists) {
                    let data = doc.data();
                    Object.assign(user, data);
                }
                resolve(user);
            })
        } else {
            const unsubscribe = firebase.auth().onAuthStateChanged(function (user) {
                unsubscribe();
                if (user) {
                    Promise.all([
                        user.getIdTokenResult(true).catch(() => { return null }),
                        firebase.firestore().doc(`auth/${user.uid}`).get(),
                    ]).then(([token,doc])=>{
                        user.claims = token.claims;
                        if (doc.exists) {
                            let data = doc.data();
                            Object.assign(user, data);
                        }
                        resolve(user);
                    })
                } else {
                    resolve(user);
                }
            });
        }
    });
}

/**@constant
 * @default
*/
const plugin = {
    install(Vue) {
        firebase.initializeApp(firebaseConfig);
        firebase.analytics();
        firebase.fetchUser = fetchUser;
        Vue.prototype.$firebase = firebase;
        Vue.prototype.$fx = firebase.app().functions('asia-east2');
    },
    fetchUser
}

/**@constant
 * @desc Vue Store Module
*/
export const store = {
    namespaced: true,
    state: {
        user: undefined,
        listeners: {}
    },
    mutations: {
        set(state, item) {
            if (!item) {
                return;
            }
            if (!item.path || typeof item.path !== "string") {
                return;
            }
            let subpaths = item.path.split("/");
            if (subpaths.length <= 0) {
                return;
            }
            let key = item.key && typeof item.key === "string" ? item.key : subpaths.pop();
            if (key === undefined || key.length <= 0) {
                return
            }
            let dir = state;
            if (subpaths.length > 0) {
                subpaths.forEach(subpath => {
                    if (dir[subpath] === undefined) {
                        Vue.set(dir, subpath, {});
                    }
                    dir = dir[subpath];
                })
            }
            Vue.set(dir, key, item.data);
        },
        del(state, item) {
            if (!item) {
                return;
            }
            if (!item.path || typeof item.path !== "string") {
                return;
            }
            let subpaths = item.path.split("/");
            if (subpaths.length <= 0) {
                return;
            }
            let key = item.key && typeof item.key === "string" ? item.key : subpaths.pop();
            if (key === undefined || key.length <= 0) {
                return
            }
            let dir = state;
            if (subpaths.length > 0) {
                subpaths.forEach(subpath => {
                    if (dir[subpath] === undefined) {
                        Vue.set(dir, subpath, {});
                    }
                    dir = dir[subpath];
                })
            }
            Vue.delete(dir, key);
        },
        clear(state, item) {
            Vue.set(state, item, {});
        },
        setListener(state, listener) {
            state.listeners[listener.target] = listener.fx;
        },
        delListener(state, listener) {
            state.listeners[listener.target]();
            state.listeners[listener.target] = null;
        }
    },
    actions: {
        listen({ commit, state }, payload) {
            let subpaths = payload.path.split('/');
            if (subpaths.length === 0) {
                return
            } else if (subpaths.length % 2 === 0) {
                let db = firebase.firestore().doc(payload.path);
                let path = payload.path;
                if (!state.listeners[path]) {
                    let listener = { target: path };
                    listener.fx = db.onSnapshot(doc => {
                        let data = {}
                        if (doc.exists) {
                            data = doc.data();
                        }
                        data.id = doc.id;
                        let item = {
                            data: data,
                            path: path
                        }
                        commit('set', item);
                    });
                    commit('setListener', listener);
                }
            } else {
                let db = firebase.firestore().collection(payload.path);
                let path = payload.path;
                if (typeof payload.where === "object") {
                    Object.keys(payload.where).forEach(field => {
                        if (typeof payload.where[field] === "object") {
                            let operator = payload.where[field].operator || '==';
                            db = db.where(field, operator, payload.where[field].value);
                        } else {
                            db = db.where(field, "==", payload.where[field]);
                        }
                    })
                }
                if (typeof payload.order === "object") {
                    db = db.orderBy(payload.order.field, payload.order.order)
                } else if (typeof payload.order === "string") {
                    db = db.orderBy(payload.order, "asc")
                }
                if (payload.startAt) {
                    db = db.startAt(payload.startAt);
                }
                if (payload.startAfter) {
                    db = db.startAfter(payload.startAfter);
                }
                if (typeof payload.limit === "number") {
                    db = db.limit(payload.limit);
                }
                let listener = { target: path };
                listener.fx = db.onSnapshot(docs => {
                    if (!docs.empty) {
                        docs.docChanges().forEach(change => {
                            let data = change.doc.data();
                            data.id = change.doc.id;
                            let item = {
                                key: data.id,
                                data: data,
                                path: path
                            }
                            switch (change.type) {
                                case "removed":
                                    commit('del', item);
                                    break;
                                default:
                                    commit('set', item);
                            }
                        })
                    } else {
                        // let item = {
                        //     path,
                        //     data: {}
                        // }
                        // commit('set', item)
                    }
                });
                commit('setListener', listener);
            }
        },
        fetch({ commit, state }, payload) {
            let subpaths = payload.path.split('/');
            if (subpaths.length === 0) {
                return
            } else if (subpaths.length % 2 === 0) {
                let db = Vue.prototype.$firebase.firestore().doc(payload.path);
                let path = payload.path;
                let key = subpaths.pop();
                let dir = state;
                subpaths.forEach(subpath => {
                    if (state[subpath] === undefined) {
                        Vue.set(state, subpath, {});
                    }
                    dir = state[subpath];
                })
                if (!payload.refresh && dir[key]) {
                    return Promise.resolve(dir[key]);
                } else if (!dir[key]) {
                    let item = {
                        path,
                        data: { loading: true },
                    }
                    if (payload.default) {
                        item.data = payload.default;
                    }
                    commit('set', item);
                    // return Promise.resolve(item.data);
                }
                return db.get().then(doc => {
                    if (doc.exists) {
                        let item = {
                            path,
                            data: doc.data(),
                        }
                        commit('set', item);
                        return item.data;
                    }
                })
            } else {
                let db = Vue.prototype.$firebase.firestore().collection(payload.path);
                let path = payload.path;
                if (typeof payload.where === "object") {
                    Object.keys(payload.where).forEach(field => {
                        if (typeof payload.where[field] === "object") {
                            let operator = payload.where[field].operator || '==';
                            db = db.where(field, operator, payload.where[field].value);
                        } else {
                            db = db.where(field, "==", payload.where[field]);
                        }
                    })
                }
                if (typeof payload.order === "object") {
                    Object.entries(payload.order).forEach(([key,field])=>{
                        db = db.orderBy(key, field);
                    })
                } else if (typeof payload.order === "string") {
                    db = db.orderBy(payload.order, "asc")
                }
                if (payload.startAt) {
                    db = db.startAt(payload.startAt);
                }
                if (payload.startAfter) {
                    db = db.startAfter(payload.startAfter);
                }
                if (typeof payload.limit === "number") {
                    db = db.limit(payload.limit);
                }
                return db.get().then(docs => {
                    let result = {};
                    if (docs.size > 0) {
                        docs.forEach(doc => {
                            let data = doc.data();
                            data.id = data.id || doc.id;
                            data.ref = doc.ref;
                            result[doc.id] = data;
                            let item = {
                                key: doc.id,
                                data: data,
                                path
                            }
                            commit('set', item);
                        })
                    } else {
                        // let item = {
                        //     path,
                        //     data: {}
                        // }
                        // if (payload.default) {
                        //     item.data = payload.default;
                        // }
                        // commit('set', item)
                    }
                    return result;
                })
            }
        },
        disconnectDB({ commit, state }) {
            Object.keys(state.listeners).forEach(key => {
                commit('delListener', { target: key })
            })
        },
        async refreshUser({ commit }) {
            let user = firebase.auth().currentUser;
            if (user) {
                let [token, doc] = await Promise.all([
                    user.getIdTokenResult(true).catch(() => { return null }),
                    firebase.firestore().doc(`auth/${user.uid}`).get(),
                ]);
                user.claims = token.claims;
                if (doc.exists) {
                    let data = doc.data();
                    Object.assign(user, data);
                }
                commit('set', { store: 'user', data: user })
                return user;
            } else {
                commit('set', { store: 'user', data: null })
                return null;
            }
        },
        signOut({ commit }) {
            firebase.auth().signOut().then(() => {
                M.toast({ html: "Sign Out Successful" });
                commit('set', { store: 'user', data: null })
                router.replace("/");
            })
        },
        signIn({ dispatch }) {
            var provider = new firebase.auth.GoogleAuthProvider();
            return firebase.auth().signInWithPopup(provider)
                .then(() => {
                    dispatch('refreshUser');
                })
                .catch(function (error) {
                    M.toast({ html: error.message });
                });
        }
    },
}

export default plugin;


if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(plugin)
}